import { httpRequest } from "@/lib/axios";
import { DocumentsFinanceEntryResponse } from "@/types";
import { useQuery } from "@tanstack/react-query";

async function fetchDocumentsFinanceEntries(
  financeEntriesId: string,
  page?: string | null
): Promise<DocumentsFinanceEntryResponse> {
  const response = await httpRequest.get<DocumentsFinanceEntryResponse>(
    `/attachments/finance-entries?page=${
      page || 1
    }&financeEntriesId=${financeEntriesId}`
  );
  return response.data;
}

export function useFetchDocumentsFinanceEntriesQuery({
  page,
  financeEntriesId,
}: {
  page?: string | null;
  financeEntriesId: string;
}) {
  const documentsFinanceEntriesQuery = useQuery({
    queryKey: ["finance-entry-documents", financeEntriesId, page],
    queryFn: () => fetchDocumentsFinanceEntries(financeEntriesId, page),
    keepPreviousData: true,
  });

  return {
    ...documentsFinanceEntriesQuery,
    data: documentsFinanceEntriesQuery?.data,
  };
}
